import { Box, Link, Image } from 'theme-ui'

import CardMeta from 'src/components/card/CardMeta'
import { getImageAsset } from 'src/lib/assets'

import type { CardProps } from 'src/components/card/Card.types'

const GridCard = ({
  image,
  title,
  description,
  link,
  cardBackgroundColor
}: Omit<CardProps, 'label'>) => {
  const imageAsset = getImageAsset({
    src: image.src,
    variant: '16x9-fullwidth'
  })

  return (
    <Box
      sx={{
        maxWidth: '868px',
        minWidth: '284px',
        height: '100%',
        backgroundColor: cardBackgroundColor
      }}
      className="tabFocusBlue"
    >
      <Link href={link} sx={{ display: 'block', height: '100%', width: '100%' }}>
        <Image src={imageAsset?.src} alt={image.alt || ''} />
        <Box sx={{ pt: [6] }}>
          <CardMeta title={title} text={description} variant={'GridCardSectionTitleSerif'} />
        </Box>
      </Link>
    </Box>
  )
}

export default GridCard
